import React from "react";
import { Step6FreezeExport } from "../../components/Step6FreezeExport";

/** Step 6 — Freeze & Export. v0.6 nav refactor: dedicated route wrapper
 *  around the existing Step6FreezeExport component (rendered active, as
 *  it is now one-per-route). */
export default function Step6Freeze() {
  return <Step6FreezeExport active />;
}
